import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { ItemVM } from 'shell/view-models/item';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';

export const reasons = Object.freeze([
  {
    id: '1',
    value: 'Smarrita',
  },
  {
    id: '2',
    value: 'Rubata',
  },
  {
    id: '3',
    value: 'Deteriorata',
  },
  {
    id: '4',
    value: 'Non consegnata',
  },
  {
    id: '5',
    value: 'Rinnovo',
  },
  {
    id: '6',
    value: 'Nuova stranieri',
  },
  {
    id: '7',
    value: 'Aire',
  },
  {
    id: '9',
    value: 'Nuova tessera',
  },
]);

interface ListReasonsProps {
  disabled?: boolean;
  required?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  error?: boolean;
}

const ListReasonsComponent = ({
  disabled,
  required,
  onChange,
  value,
  error,
}: ListReasonsProps): React.ReactElement => {
  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id="gender-label">
        {required ? 'Motivo rilascio *' : 'Motivo rilascio'}
      </InputLabel>
      <PmiSelect
        labelId="reasons-label"
        id="reasons"
        name="reasons"
        value={value}
        label={required ? 'Motivo rilascio *' : 'Motivo rilascio'}
        onChange={onChange}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {reasons.map((reason: ItemVM) => (
          <MenuItem key={reason.id} value={reason.id}>
            {reason.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ListReasonsComponent.displayName = 'List reason component';

const ListReasons = memo(ListReasonsComponent);

export default ListReasons as typeof ListReasonsComponent;
